import { render, staticRenderFns } from "./assign-contacts-by-tag.vue?vue&type=template&id=4ca5f5ac"
import script from "./assign-contacts-by-tag.vue?vue&type=script&lang=js"
export * from "./assign-contacts-by-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports